import { isAdminPanel } from '$utils';

export const useAdminPanel = () => isAdminPanel();
